export default __webpack_public_path__ + "static/36-00c9d39967c99d182eed0aa09efef735.png";